import React from 'react';
import FooterSection from '../FooterSection';
import Navigation from '../Navigation';
import { SEO } from '../SEO';
import AnimatedSun from '../AnimatedSun';

interface HomeLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout component for the Home page
 */
const HomeLayout: React.FC<HomeLayoutProps> = ({ children }) => {
  return (
    <>
      <SEO
        title="Home"
        description="Alio IT offers software development consulting, remote teams, QA automation, and DevOps services from Latin America and India."
        keywords={[
          'Software Development Consulting',
          'Remote software development teams',
          'QA Automation services',
          'DevOps consulting',
          'Software testing services Latin America'
        ]}
      />
      <main style={{ 
        width: '100%',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        background: '#050505',
        paddingTop: '99px',
      }}>
        <Navigation />
        <AnimatedSun />
        {children}
        <FooterSection />
      </main>
    </>
  );
};

export default HomeLayout; 